<template>
  <div>
    <el-form ref="formRef" :model="userForm" label-width="140px">
      <el-form-item label="头像：">
        <el-image style="width: 80px; height: 80px" :src="userForm.headImg.smallHeadImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
      </el-form-item>
      <el-form-item label="信息：">
        <div class="item-info">
          <UserInfoList :row="userForm" showList="name,phone,uid,city,birth"/>
          <p>身高：{{ userForm.height }}cm</p>
          <p>达人状态：{{userForm.talentStatus == 0?'未提交':userForm.talentStatus == 1?'待审核':userForm.talentStatus == 2?'已通过':userForm.talentStatus == 3?'不通过':''}}</p>
        </div>
      </el-form-item>
<!--      <el-form-item label="状态：">-->
<!--        <div class="item-info">-->
<!--          <p>真人认证状态：{{userForm.baiduMatchState == 0?'未认证':userForm.baiduMatchState == 1?'已认证':userForm.baiduMatchState == 2?'认证失败':''}}</p>-->
<!--          <p>实名认证：{{userForm.baiduAuthState == 0?'未认证':userForm.baiduAuthState == 1?userForm.baiduAuth.certCode:userForm.baiduAuthState == 2?'认证失败':''}}</p>-->
<!--          <p>信息审核状态：{{userForm.resumeState == 0?'未提交':userForm.resumeState == 1?'待审核':userForm.resumeState == 2?'审核通过':userForm.resumeState == 3?'审核不通过':''}}</p>-->
<!--        </div>-->
<!--      </el-form-item>-->
      <el-form-item label="本周积分数量：" style="margin: 16px 0;">{{userForm.thisWeekIntegral}}</el-form-item>
      <el-form-item label="输入数量：" >
        <el-input v-model="num" placeholder="请输入整数" style="width: 90%"></el-input>
        <p style="color: red">*允许输入负数，负数则代表扣罚对应的数量</p>
      </el-form-item>
      <el-form-item label="账单名称：" >
        <el-input v-model="name" placeholder="20字以内" style="width: 90%"></el-input>
      </el-form-item>
      <el-form-item>
        <div class="dialog-footer">
          <el-button @click.native="cancel" >取消</el-button>
          <el-button type="primary" @click="submit" v-loading="loading">确定</el-button>
        </div>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import { postFormData } from "@/api/api";
import { updateTalentIntegral } from "@/api/url";
import { intReg } from "@/assets/shared/reg-constant";

export default {
  name: "ApplySearchInfoDialog",
  props: {
    value: Object
  },
  data() {
    return {
      userForm: this.value.userForm,
      loading: false,
      num: '',
      name: '',
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    submit() {
      if(!intReg.test(this.num)){
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请输入整数',
          type: 'warning'
        });
        return false
      }
      if(this.name.length > 20){
        this.$message({
          showClose: true,
          duration: 1000,
          message: '账单名称超过20个字',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {}
      param['id'] = this.userForm.userId
      param['integralNum'] = this.num
      param['name'] = this.name
      postFormData(updateTalentIntegral, param).then((data) => {
        let {code, msg} = data
        if ( code == 200 ) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          this.$emit('confirm')
        } else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.item-info {
  margin-top: 4px;
}
.item-info p {
  line-height: 24px;
}
</style>
